import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './Fixed.module.scss'

const propTypes = {
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  position: PropTypes.oneOf(['top', 'bottom', 'left', 'right'])
}

const defaultProps = {
  element: 'div',
  position: 'top'
}

const Fixed = ({ element: Component, className, position, ...restProps }) => (
  <Component
    className={classnames(className, styles[position])}
    {...restProps}
  />
)

Object.assign(Fixed, { propTypes, defaultProps })

export default Fixed
